import React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import classnames from 'classnames';

import base from '../../base.styl';
import styles from './Bills.styl';

const Bills = props => {
  return (
    <div style={{ position: 'relative' }}>
      <Grid fluid className={classnames(base.container, styles.block)}>
        <Row center="xs" className={styles.bills_row}>
          <Col xs={12} sm={6} className={styles.col}>
            <h1 className={styles.headline}>HARMFUL BILLS</h1>
            <p className={styles.paragraph} style={{marginBottom: '30px'}}>New anti-ESA bills are being introduced at an alarming pace. Here are a few of the most dangerous bills—please urge your members of Congress to oppose these measures and all legislative attacks on the ESA.</p>
          </Col>
        </Row>
        <Row className={styles.bills_row}>
          <Col xs={12} sm={6} className={styles.col}>
            <p className={styles.infoParagraph}>
              <span className={styles.italic}>
                Gray Wolf State Management Act (H.R. 424/S. 164)
              </span>
               – If enacted, this legislation would block ESA protections for
              imperiled gray wolves in the western Great Lakes region and
              Wyoming, and would preclude challenges to the delisting in court.
              A U.S. House committee approved H.R. 424 in early October, and
              this dangerous, anti-wildlife bill could soon be considered by the
              full chamber.
            </p>
          </Col>
          <Col xs={12} sm={6} className={styles.col}>
            <p className={styles.infoParagraph}>
              <span className={styles.italic}>
                Listing Reform Act (H.R. 717)
              </span>
               – This bill proposes to allow economic considerations to be a
              determining factor in ESA listing decisions and to weaken the
              existing listing petition process. It ignores the principle that
              ESA protections are to be applied based on scientific
              considerations, not cost calculations. A U.S. House committee
              approved H.R. 717 in early October, and it could soon be
              considered by the entire House.
            </p>
          </Col>
        </Row>
        <Row className={styles.bills_row}>
          <Col xs={12} sm={6} className={styles.col}>
            <p className={styles.infoParagraph}>
              <span className={styles.italic}>
                State, Tribal, and Local Species Transparency and Recovery Act
                (H.R. 1274)
              </span>
               – This bill would undermine the ESA’s mandate that listing
              decisions be made based up on the best available science. It would
              prioritize information submitted by states—regardless of its
              legitimacy or scientific basis—above other data in making listing
              decisions for imperiled wildlife. A U.S. House committee approved
              H.R. 1274 in early October, and it could soon be voted on by the
              full chamber.
            </p>
          </Col>
          <Col xs={12} sm={6} className={styles.col}>
            <p className={styles.infoParagraph}>
              <span className={styles.italic}>
                Saving America’s Endangered Species Act (H.R. 2603)
              </span>
               – H.R. 2603 would amend the Endangered Species Act to remove
              protections for non-U.S. species—including some of he world’s most
              iconic animals—potentially disrupting efforts to fight wildlife
              trafficking and restrict trophy hunting. A U.S. House committee
              approved H.R. 2603 in early October.
            </p>
          </Col>
        </Row>
        <Row className={styles.bills_row}>
          <Col xs={12} sm={6} className={styles.col}>
            <p className={styles.infoParagraph}>
              <span className={styles.italic}>
                Endangered Species Litigation Reasonableness Act (H.R. 3131)
              </span>
               – If enacted, H.R. 3131 would interfere with the public’s role in
              enforcing the ESA by creating obstacles to citizen lawsuits. A
              U.S. House committee approved H.R. 3131 in early October; the full
              House could soon take it up for consideration.
            </p>
          </Col>
          <Col xs={12} sm={6} className={styles.col}>
            <p className={styles.infoParagraph}>
              <span className={styles.italic}>
                Native Species Protection Act (S. 1863)
              </span>
               – S. 1863 would preclude ESA protection for any species that is
              found only within the boundaries of a single state. This arbitrary
              standard for protection ignores sound science and wildlife
              conservation principles.
            </p>
          </Col>
        </Row>
      </Grid>
    </div>
  );
};

export default Bills;



// WEBPACK FOOTER //
// ./src/components/static/Bills.js